export const recruitmentAdminFTs = {
  recruitmentAdminApprovalFlow: { dev: true, sit: false, uat: false, prod: false },
  oldScore: { dev: false, sit: false, uat: false, prod: false },
};
